var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputCollectionPlusBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 771381"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10848",
    x: 0.5,
    y: 0.499908,
    width: 29,
    height: 27.2857,
    rx: 3.5,
    fill: "white",
    stroke: "#CFDAE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M20.5716 12.8603V15.1414H9.42871V12.8603H20.5716ZM16.3065 8.57133V19.7142H13.705V8.57133H16.3065Z",
    fill: "#787A7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCollectionPlusBtn);
export default __webpack_public_path__ + "static/media/inputCollectionPlusBtn.0777fbdb80462927353bcc9c6f29d0e8.svg";
export { ForwardRef as ReactComponent };